import actionCreatorFactory from "typescript-fsa";

const actionCreator = actionCreatorFactory("system");
export const systemActions = {
  SYSTEM_INITIALIZE_APPLICATION: actionCreator("SYSTEM_INITIALIZE_APPLICATION")
};
